// Este archivo maneja el registro del service worker

// Esta función determina si la aplicación se está ejecutando en producción
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

type Config = {
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
};

export function register(config?: Config): void {
  if ('serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL || '', window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Si PUBLIC_URL está en un origen diferente al de la aplicación,
      // el service worker no funcionará
      return;
    }

    window.addEventListener('load', () => {
      // Registrar el service worker principal (solo en producción)
      if (process.env.NODE_ENV === 'production') {
        const swUrl = `${process.env.PUBLIC_URL}/serviceWorker.js`;

        if (isLocalhost) {
          checkValidServiceWorker(swUrl, config);
          navigator.serviceWorker.ready.then(() => {
            console.log('Esta aplicación web está siendo servida en caché por un service worker.');
          });
        } else {
          registerValidSW(swUrl, config);
        }
      }

      // Registrar el service worker de Firebase Messaging (siempre)
      registerFirebaseMessagingSW();
    });
  }
}

// Registrar el service worker de Firebase Messaging para notificaciones push
function registerFirebaseMessagingSW(): void {
  const firebaseSwUrl = '/firebase-messaging-sw.js';

  navigator.serviceWorker
    .register(firebaseSwUrl)
    .then((registration) => {
      console.log('Firebase Messaging SW registrado con éxito:', registration.scope);
    })
    .catch((error) => {
      console.error('Error al registrar Firebase Messaging SW:', error);
    });
}

function registerValidSW(swUrl: string, config?: Config): void {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // En este punto, el contenido actualizado ha sido obtenido,
              // pero el service worker anterior seguirá sirviendo el contenido
              // antiguo hasta que todas las pestañas del cliente se cierren.
              console.log('Nuevo contenido disponible. Por favor, actualiza la página.');

              // Ejecutar callback
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // En este punto, todo ha sido precacheado.
              console.log('El contenido está almacenado en caché para uso sin conexión.');

              // Ejecutar callback
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Error durante el registro del service worker:', error);
    });
}

function checkValidServiceWorker(swUrl: string, config?: Config): void {
  // Verificar si se puede encontrar el service worker
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      // Asegurarse de que el service worker existe y que realmente obtenemos un archivo JS
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No se encontró el service worker, probablemente sea una aplicación diferente
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker encontrado, proceder normalmente
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('No se encontró conexión a internet. La aplicación se ejecuta en modo offline.');
    });
}

export function unregister(): void {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
